import { useTranslation } from 'react-i18next';

import { Action, Icon } from '@soluto-private/mx-asurion-ui-react';

import { useAnalytics } from '@service-initiation/shared-data-access-analytics';
import { TranslationEntries } from '@service-initiation/tech-care-data-access-i18n';

export interface StoreHoursButton {
  setModalOpen: (state: boolean) => void;
  variant?: 'button' | 'link';
}

const TEXT = TranslationEntries.Repairs.Confirmation;

export const StoreHoursButton = ({
  setModalOpen,
  variant = 'link',
}: StoreHoursButton) => {
  const { t } = useTranslation();
  const { dispatchClickEvent } = useAnalytics();

  const handleClick = () => {
    dispatchClickEvent('StoreHours');
    setModalOpen(true);
  };

  return variant === 'link' ? (
    <Action
      color="secondary"
      data-testid="StoreHoursButton"
      onClick={handleClick}
      target="_blank"
      variant="flat"
    >
      {t(TEXT.StoreHours)}
    </Action>
  ) : (
    <Action
      color="primary"
      data-testid="StoreHoursButton"
      onClick={handleClick}
      size="md"
      variant="outline"
    >
      <Icon src="time" />
      {t(TEXT.StoreHours)}
    </Action>
  );
};
